<template lang="pug">
  form.b-comment-form
    ._header
      UserAvatar(:user="$store.state.auth.user")
      WysiwygToolbar._toolbar#toolbar
      CommentReplyTile._reply(:to="comment.replyTo" removable @remove="removeReply" @click="scrollToComment")
    WysiwygEditor._editor(toolbar="#toolbar" label="" v-model="text" @input="onCommentUpdated" @dropFiles="$emit('dropFiles', $event)")
    slot(name="files")
    ._buttons
      Btn(v-if="isEdit" @click="onCancel") Отмена
      Btn(:green="isEdit" @click="onSubmit") {{ isEdit ? 'Сохранить' : 'Опубликовать' }}
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';
import WysiwygToolbar from '@/components/WysiwygToolbar.vue';
import WysiwygEditor from '@/components/WysiwygEditor.vue';
import CommentReplyTile from '@/components/CommentReplyTile.vue';

export default {
  name: 'CommentForm',
  components: { UserAvatar, WysiwygToolbar, WysiwygEditor, CommentReplyTile }, // eslint-disable-line
  model: { prop: 'comment', event: 'input' },
  props: {
    comment: Object,
  },
  data() {
    return {
      text: '',
    };
  },
  computed: {
    updatedComment() { return { ...this.comment, info: { text: this.text } }; },
    isEdit() { return this.comment?.isDraft === false; },
  },
  watch: {
    'comment.info.text': {
      immediate: true,
      handler(val) { this.text = val; },
    },
  },
  methods: {
    scrollToComment() {
      this.$emit('scrollToComment', this.comment.replyTo['@id']);
    },
    removeReply() {
      this.$emit('input', { ...this.updatedComment, replyTo: null });
    },
    onCommentUpdated() {
      this.$emit('input', this.updatedComment);
    },
    onSubmit() {
      this.$emit('submit', this.updatedComment);
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="scss">
.comment-form {
  display: grid;
  grid-template-columns: 100%;
  row-gap: 20px;

  &__header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__toolbar {
    top: 0;
  }

  &__reply {
    margin-left: auto;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  @media (max-width: 900px) {
    &__header {
      flex-wrap: wrap;
    }

    &__reply {
      order: -1;
      width: 100%;

      ::v-deep :first-child {
        margin-left: auto;
      }
    }
  }
}
</style>
